import React from 'react';
import {useTranslation} from 'react-i18next';
import {
    Box,
    TextField,
    Button
} from '@mui/material';
import { EndScreen } from 'crqlar-react-common/dist/models/forms/form';
import EditableTypography from 'crqlar-react-common/dist/components/EditableTypography';
import MdEditor from 'crqlar-react-common/dist/components/MdEditor';

interface EndScreenEditorProps {
    question: EndScreen;
    onQuestionUpdate: (question: EndScreen) => void;
}

const EndScreenEditor: React.FC<EndScreenEditorProps> = ({
                                                             question,
                                                             onQuestionUpdate
                                                         }) => {
    const {t} = useTranslation();

    // Handle title update
    const handleTitleUpdate = (title: string) => {
        onQuestionUpdate({
            ...question,
            title
        });
    };

    // Handle description update
    const handleDescriptionUpdate = (description?: string) => {
        onQuestionUpdate({
            ...question,
            description: description || ''
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                p: 2,
            }}
        >
            {/* Title */}
            <EditableTypography
                value={question.title}
                onChange={handleTitleUpdate}
                multiline
                variant="h6"
                sx={{
                    mb: 2,
                    width: '100%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    '& input': {
                        textAlign: 'center',
                    },
                    padding: '8px',
                    borderRadius: 1,
                }}
                placeholder={t('Thank you')}
            />

            {/* Description */}
            <Box sx={{mb: 4, width: '100%'}}>
                <MdEditor
                    value={question.description || ''}
                    onChange={handleDescriptionUpdate}
                    placeholder={t('Closing Message (optional)')}
                    className={'mini-mdx'}
                />
            </Box>

            {/* Email Input - Readonly preview if collectEmail is enabled */}
            {question.collectEmail && (
                <Box sx={{ width: '100%', mb: 2, maxWidth: 400 }}>
                    <TextField
                        disabled
                        placeholder={question.emailPlaceholder || t('Enter your email address')}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={{
                            borderRadius: 1,
                        }}
                    />
                </Box>
            )}

            {/* Button - Readonly preview */}
            <Box
                sx={{
                    display: 'inline-block',
                }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    disabled
                    sx={{
                        textTransform: 'none',
                        fontSize: '1rem',
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                    }}
                >
                    {question.buttonText || t('Submit')}
                </Button>
            </Box>
        </Box>
    );
};

export default EndScreenEditor;
